module.exports = __webpack_public_path__ + "img/logo-mo-36.e0df48d6.svg";